import { useAppSelector } from "./useRedux";


export default function useGetClientAIConsent():boolean {
    return useAppSelector(state => state?.user?.account?.client?.openAiConsentGiven!!);
}
